import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "_flexcol _gap-3",
  "data-qa": "partner-network:IntroSection"
}
const _hoisted_2 = { class: "_flexcol _gap-5 _ma-0" }
const _hoisted_3 = {
  key: 0,
  ref: "partnersSection",
  class: "_scroll-offset-nav"
}
const _hoisted_4 = { class: "_flex _gap-1 _ai-b" }
const _hoisted_5 = { class: "_grid _grid-cols-1 _grid-cols-2--m _gap-5" }
const _hoisted_6 = {
  key: 0,
  class: "_flex _jc-c _mt-6"
}
const _hoisted_7 = { class: "_flex _jc-c _mt-6" }
const _hoisted_8 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_base_text = _resolveComponent("base-text")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_hero = _resolveComponent("base-hero")
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_box = _resolveComponent("box")
  const _component_base_tab = _resolveComponent("base-tab")
  const _component_base_tabs = _resolveComponent("base-tabs")
  const _component_partner_card = _resolveComponent("partner-card")
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_base_container = _resolveComponent("base-container")
  const _component_partner_detail_modal = _resolveComponent("partner-detail-modal")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, { "is-processing": _ctx.isProcessing }, {
    default: _withCtx(() => [
      _createVNode(_component_footer_navigation, {
        "current-page": _ctx.Resources.Layout.PartnerNetworkLink
      }, null, 8 /* PROPS */, ["current-page"]),
      _createVNode(_component_base_hero, {
        title: _ctx.Resources.PartnerNetwork.HeroTitle,
        type: "partner",
        "data-qa": "partner-network:HeroBanner"
      }, {
        description: _withCtx(() => [
          _createVNode(_component_base_text, {
            as: "div",
            level: "b1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($options.heroDescription), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_base_button, {
            theme: "accent",
            class: "_mt-5",
            onClick: $options.onBrowseClick,
            "data-qa": "partner-network:BrowsePartners"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.BrowsePartnersButton), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]),
      _createVNode(_component_base_container, {
        width: "narrow",
        class: "_py-6 _flexcol _gap-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_title, {
              as: "h2",
              level: "h1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.MeetOurPartnersHeader), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_text, {
              as: "div",
              level: "b1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.introParagraph), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_text, {
              as: "div",
              level: "b1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.CategoriesIntro), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createVNode(_component_box, { thick: true }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.explainerCategories, (category) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: category.id,
                    class: "_flex _gap-3"
                  }, [
                    _createVNode(_component_base_icon, {
                      name: category.icon,
                      size: "lg",
                      "is-fixed-width": "",
                      class: "_tc--accent"
                    }, null, 8 /* PROPS */, ["name"]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_base_title, {
                        as: "h4",
                        level: "h3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_base_text, {
                        as: "div",
                        level: "b1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.description), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _: 1 /* STABLE */
          }),
          ($options.hasPartners)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_base_title, {
                    as: "h3",
                    level: "h2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.PartnersHeader), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_base_text, {
                    as: "span",
                    class: "_tc--light",
                    "data-qa": "partner-network:ResultsHeader"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.resultsLabel), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _createVNode(_component_base_tabs, {
                  tag: "nav",
                  scrollable: "",
                  class: "_gap-2 _mb-5",
                  "aria-label": "Partner categories"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tabs, (tab) => {
                      return (_openBlock(), _createBlock(_component_base_tab, {
                        key: tab.id,
                        variant: "link",
                        "is-active": tab.id === $data.activeCategory,
                        onClick: _withModifiers($event => ($options.onSelectCategory(tab.id)), ["prevent"]),
                        "data-qa": `partner-network-tab:${tab.id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-active", "onClick", "data-qa"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visiblePartners, (partner) => {
                    return (_openBlock(), _createBlock(_component_partner_card, {
                      key: partner.partnerID,
                      partner: partner,
                      onOpenPartner: $options.onOpenPartner,
                      onSelectCategory: $options.onSelectCategory
                    }, null, 8 /* PROPS */, ["partner", "onOpenPartner", "onSelectCategory"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                ($options.isMoreButtonVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_processing_button, {
                        theme: "outline",
                        onClick: $options.onLoadMore,
                        "data-qa": "partner-network:LoadMore"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ]))
                  : _createCommentVNode("v-if", true),
                ($options.canInfiniteScroll)
                  ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                      key: 1,
                      onLoadMore: $options.onLoadMore
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_processing_button, { "is-processing": true }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onLoadMore"]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_base_text, {
                  as: "div",
                  class: "_tac _mt-6 _tc--light"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.PartnerNetwork.JoinPrompt) + " ", 1 /* TEXT */),
                    _createElementVNode("a", {
                      href: $options.joinContactUrl,
                      class: "_tc--accent",
                      "data-qa": "partner-network:JoinLink"
                    }, _toDisplayString(_ctx.Resources.PartnerNetwork.JoinLinkLabel), 9 /* TEXT, PROPS */, _hoisted_8)
                  ]),
                  _: 1 /* STABLE */
                })
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_partner_detail_modal, {
        partner: $data.selectedPartner,
        "is-visible": $options.isPartnerModalVisible,
        onClose: $options.onClosePartnerModal,
        onPrev: _cache[0] || (_cache[0] = $event => ($options.goToAdjacentPartner(-1))),
        onNext: _cache[1] || (_cache[1] = $event => ($options.goToAdjacentPartner(1)))
      }, null, 8 /* PROPS */, ["partner", "is-visible", "onClose"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-processing"]))
}